import { useContext, useMemo } from "react";
import { LocalizationContext } from "./LocalizationProvider";
import { LocalizedText, LocalizationValues } from "./LocalizationTypes";

export const useLocalizedText = (key: LocalizedText): string => {
    const context = useContext(LocalizationContext)

    if (context === null) {
        throw 'Localization Provider could not be found, please make sure you wrap the application with the LocalizationProvider component'
    }

    return useMemo(() => context.getTranslationText(key), [key, context.getTranslationText]);
}

export const useLocalizedTextArray = (keys: LocalizedText[]): string[] => {
    const context = useContext(LocalizationContext)

    if (context === null) {
        throw 'Localization Provider could not be found, please make sure you wrap the application with the LocalizationProvider component'
    }

    // This is really ugly but is actually recommended by dan abromov, im not sure why react hasnt added an api for deep checking an array for dependencies
    return useMemo(() => keys.map(key => context.getTranslationText(key)), [keys.length, JSON.stringify(keys)]);
}

export const useMultipleLocalizedText = (): LocalizationValues => {
    const context = useContext(LocalizationContext)

    if (context === null) {
        throw 'Localization Provider could not be found, please make sure you wrap the application with the LocalizationProvider component'
    }

    return context.translations
}

export const useLocaleType = (): string => {
    const context = useContext(LocalizationContext)

    if (context === null) {
        throw 'Localization Provider could not be found, please make sure you wrap the application with the LocalizationProvider component'
    }

    return context.locale
}
